/* eslint-disable @typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars */

xplenty.directive('steps', [
  '$compile',
  '$templateCache',

  function ($compile, $templateCache) {
    return {
      restrict: 'E',

      controller: 'StepsController',

      scope: null,

      transclude: true,

      template: '<div class="steps" ng-transclude></div>',

      compile(element, attrs) {
        // var $steps = element.find('step');
        // var $newElement = angular.element('<div class="steps"></div>');

        // element.replaceWith($newElement);

        return {
          pre(scope, element, attrs, controller, transcludeFn) {},

          post(scope, element, attrs, controller, transcludeFn) {
            //
            // $steps.each(function(index, step) {
            //
            //     var $step = angular.element(this);
            //     var stepHtml = $step.html();
            //
            //     $step.empty();
            //
            //     var html = angular.element("<div />").append($step.clone()).html();
            //     var $stepCompiled = $compile(html)(scope);
            //
            //     $stepCompiled.data('html', stepHtml);
            //     $stepCompiled.data('index', index);
            //     $stepCompiled.data('isLast', (index + 1) === $steps.length);
            //
            //     element.append($stepCompiled);
            //
            // });
          },
        };
      },
    };
  },
]);
